type Props = {
  partnerName: string;
  onStart: () => void;
};

export function AssessmentIntro({ partnerName, onStart }: Props) {
  return (
    <div className="mx-auto flex min-h-screen min-h-dvh max-w-md flex-col px-6 py-12 text-center">
      {/* Body is vertically centered in the remaining viewport; Begin sits at the bottom. */}
      <div className="flex flex-1 flex-col items-center justify-center">
        <p className="wren-eyebrow mb-4 text-[0.875rem]">Takes 3 minutes</p>
        <h1 className="mb-6 text-[3rem] leading-[100%]">How You Receive Love</h1>
        <p className="mb-4 text-[1.25rem] leading-[150%] text-[color:var(--color-wren-gray-700)]">
          Everyone feels loved differently. This is a quick way to find out how
          you do, and how {partnerName} does.
        </p>
        <p className="text-[1rem] leading-[1.5rem] text-[color:var(--color-wren-supporting)]">
          No right answers. Trust your gut.
        </p>
      </div>
      <button
        onClick={onStart}
        className="w-full bg-[color:var(--color-wren-green)] px-6 py-4 text-[1rem] font-semibold text-white transition-colors duration-150 hover:bg-[color:var(--color-wren-green-dark)] active:bg-[color:var(--color-wren-green-deep)]"
        style={{
          borderRadius: "var(--radius-wren-button)",
          boxShadow: "var(--shadow-wren-button-inset)",
        }}
      >
        Begin
      </button>
    </div>
  );
}
